// extracted by mini-css-extract-plugin
export default {"hidden":"scroll_hidden__qQF20","visible":"scroll_visible__ydhw2"};